(function () {
	'use strict';

	angular.module('mx.shell').controller('mx.shell.UnauthorizedPageController', function unauthorizedPageController() {});
})();
